import { agroApi } from "../api";
import { ResponseDataGet } from "../../../models/responseDataGet";
import { Paths } from "../../../paths";
import { EntProcessingCapacity } from "../../../models/organic/processingCapacity";
import { EntProcessingCapacityFilter } from "../../../models/filters/organic/processingCapacityFilter";

export const processingCapacityApi = agroApi.injectEndpoints({
  endpoints: (builder) => ({
	getProcessingCapacityList: builder.query<ResponseDataGet<EntProcessingCapacity>, EntProcessingCapacityFilter>({
	  query: (filter) => ({
		url: `${ Paths.organic.processingCapacity }/get-all`,
		method: "POST",
		body: JSON.stringify(filter),
	  }),
	}),

	getProcessingCapacityById: builder.query<ResponseDataGet<EntProcessingCapacity>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.processingCapacity }/${ id }`,
		method: 'GET',
	  }),
	}),

	addProcessingCapacity: builder.mutation<ResponseDataGet<EntProcessingCapacity>, EntProcessingCapacity>({
	  query: (body) => ({
		url: `${ Paths.organic.processingCapacity }`,
		method: "POST",
		body: JSON.stringify(body),
	  }),
	}),

	editProcessingCapacity: builder.mutation<ResponseDataGet<EntProcessingCapacity>, EntProcessingCapacity>({
	  query: (body) => ({
		url: `${ Paths.organic.processingCapacity }`,
		method: 'PUT',
		body: JSON.stringify(body),
	  }),
	}),

	deleteProcessingCapacity: builder.mutation<ResponseDataGet<EntProcessingCapacity>, number>({
	  query: (id) => ({
		url: `${ Paths.organic.processingCapacity }/${ id }`,
		method: 'DELETE',
	  }),
	}),
  }),
  overrideExisting: false,
});

export const {
  useGetProcessingCapacityListQuery,
  useGetProcessingCapacityByIdQuery,
  useAddProcessingCapacityMutation,
  useEditProcessingCapacityMutation,
  useDeleteProcessingCapacityMutation,
  useLazyGetProcessingCapacityListQuery
} = processingCapacityApi;
